/**
 * Source badge for a validation rule (CZNA-245).
 *
 * ALEPH_CONVERTED rules (seeded from the legacy engine, ~360) get a blue
 * badge; MANUAL rules get a green one. Plain inline-styled span per the
 * project styling rule (no separate CSS files).
 */
import React from 'react';
import { useIntl } from 'react-intl';
var STYLES = {
    ALEPH_CONVERTED: { bg: '#e7f0fb', fg: '#1c4f9c', border: '#b9d3f2' },
    MANUAL: { bg: '#e6f4ea', fg: '#1e7e34', border: '#bfe3c8' },
};
var RuleSourceBadge = function (_a) {
    var _b;
    var source = _a.source;
    var intl = useIntl();
    var palette = (_b = STYLES[source]) !== null && _b !== void 0 ? _b : STYLES.MANUAL;
    return (React.createElement("span", { "data-testid": "rule-source-".concat(source), style: {
            display: 'inline-block',
            backgroundColor: palette.bg,
            color: palette.fg,
            border: "1px solid ".concat(palette.border),
            borderRadius: '10px',
            padding: '0 8px',
            fontSize: '0.8em',
            fontWeight: 600,
            whiteSpace: 'nowrap',
        } }, intl.formatMessage({ id: "ui-czna-authorities.validationRules.source.".concat(source) })));
};
export default RuleSourceBadge;
